import './TSpinner.css';

import React from 'react';
import { Modal } from 'react-bootstrap';
import { Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';

const TSpinner = props => {
    return (
        <div className='t-spinner'>
            <Modal show={props.show || props.loading.spinnerKeys.length}
                className='t-spinner-modal'
                dialogClassName='t-spinner-modal-dialog'
                onHide={() => { return; }}
                animation={false}
            >
                <div className='t-spinner-icon'>
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            </Modal>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        loading: state.loading
    };
};

export default connect(mapStateToProps)(TSpinner);